import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import '../CustomNode/CustomNode.css';

function CustomNodeCost({id, data}:any) {
  
  return (
    <>
      
      <div className="custom-node__bodyCost nowheel">
      <Handle
        type="source"
        position={Position.Bottom}
        id="a"
      />
        <h3 style={{textAlign: 'center'}}>{id}</h3>
        
        <Handle
        type="target"
        position={Position.Top}
        id="b"
      />
      </div>
    </>
  );
}

export default memo(CustomNodeCost);
